import { createEvent, createStore, sample } from 'effector';
import { $resetAuth } from './profile-entity';

export interface ICardListItem {
	id: number;
	clientId: string;
	buildId: string;

	number?: string;
	date?: string;
	balanceDate?: string;
	balance?: number | null;

	takeStatus?: 0 | 1 | 2 | 3;
	takenFrom?: string;

	createdAt: string;
}

export const $resetPanelState = createEvent();

export const $setIsFetchingCards = createEvent<boolean>();
export const $isFetchingCards = createStore<boolean>(false).on($setIsFetchingCards, (_, payload) => payload).reset($resetPanelState);

export const $setHasMoreCards = createEvent<boolean>();
export const $hasMoreCards = createStore<boolean>(false).on($setHasMoreCards, (_, payload) => payload).reset($resetPanelState);

export const $setCursorCards = createEvent<string | null>();
export const $cursorCards = createStore<string | null>(null).on($setCursorCards, (_, payload) => payload).reset($resetPanelState);

export const $setCards = createEvent<ICardListItem[]>();
export const $addCards = createEvent<ICardListItem[]>();
export const $updateCardsByClientId = createEvent<Partial<ICardListItem> & { clientId: string }>();

export const $cards = createStore<ICardListItem[]>([])
	.on($setCards, (_, payload) => payload)
	.on($addCards, (state, payload) => {
		return [...state, ...payload];
	})
	.on($updateCardsByClientId, (state, payload) => {
		const newState = state.map(item => {
			if (item?.clientId === payload?.clientId) return { ...item, ...{ ...payload, id: item.id } };
			else return item;
		});

		return [...newState];
	})
	.reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
